import { capitalize } from '@mui/material/utils';

import { Contact } from '@work4all/models/lib/Classes/Contact.entity';
import { EMail } from '@work4all/models/lib/Classes/EMail.entity';
import { User } from '@work4all/models/lib/Classes/User.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { SdObjType } from '@work4all/models/lib/Enums/SdObjType.enum';

import { isCustomer } from '../../../../../../components/data-tables/MailboxContentTable/cells/contact-or-business-partner';
import { OverlayTemplate } from '../../../hooks/use-overlay-template';

export function calculateToMailContacts(
  template: OverlayTemplate<EMail>
): string | undefined {
  const data = template.data;
  const entity = template.sourceEntity;
  return JSON.stringify(calculateToMailContact({ ...data, entity }));
}

export function calculateToMailContact(
  data: OverlayTemplate<EMail>['data'] & { entity?: Entities }
) {
  const businessPartnerType = isCustomer(data.businessPartner?.data)
    ? SdObjType.KUNDE
    : SdObjType.LIEFERANT;

  function getEmailFromContact(contact: Contact) {
    const typeName = capitalize(
      (
        contact?.businessPartnerType ||
        data.businessPartnerType ||
        businessPartnerType
      ).toLowerCase()
    );

    if (contact) {
      const id = `${typeName}Ap_${contact.id}`;
      return contact?.eMail
        ? [
            {
              id,
              mailAddress: contact.eMail,
              contact: contact,
            },
          ]
        : [];
    }
  }

  const getEmailFromCompany = () => {
    const bp = data.businessPartner?.data;

    if (bp?.eMail && bp?.id) {
      const typeName = bp.__typename
        ? bp.__typename
        : getBusinessPartnerPrefix(
            data.businessPartnerType || businessPartnerType
          );

      const id = `${typeName}_${bp.id}`;
      return bp?.eMail
        ? [
            {
              id,
              mailAddress: bp?.eMail,
            },
          ]
        : [];
    }
  };

  if (data.contact) {
    if (data.contact?.eMail) {
      return getEmailFromContact(data.contact);
    } else {
      const result = getEmailFromCompany();
      return (
        result || getEmailFromContact(data.businessPartner?.data.mainContact)
      );
    }
  }
  if (data.entity === Entities.user && data.id) {
    return [
      {
        id: `Mitarbeiter_${data.id.toString()}`,
        mailAddress: (data as User)?.eMail,
      },
    ];
  }
  if (data.businessPartner?.data.mainContact) {
    return getEmailFromContact(data.businessPartner?.data.mainContact);
  }
  return getEmailFromCompany();
}

const getBusinessPartnerPrefix = (businessPartnerType: SdObjType) => {
  if (businessPartnerType === SdObjType.LIEFERANT) return 'Lieferant';
  return 'Kunde';
};
